<div class="d-flex justify-content-between align-items-end pb-3 autocomlete-header">
  <h2 mat-dialog-title class="text-black fw-medium p-0 mb-0">{{ 'eventAuditTrail.users' | translate }}</h2>
  <button class="border-0 bg-transparent delete-btn" (click)="dialogRef.close()">
    <i class="das das-corss fs-12 close-btn"></i>
  </button>
</div>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="example-full-width">
    <input
      type="text"
      matInput
      [formControl]="myControl"
      (paste)="onManualInput($event)"
      (input)="onManualInput($event)"
      [matAutocomplete]="auto"
      [matAutocompleteDisabled]="!showAutocomplete"
      placeholder="{{ 'eventAuditTrail.selectUsers' | translate }}"
    />

    @if (loading) {
      <mat-icon matSuffix class="spinner-icon mt-2 pe-1">
        <mat-progress-spinner mode="indeterminate" diameter="27" strokeWidth="3" color="primary"></mat-progress-spinner>
      </mat-icon>
    }

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
      @for (option of filteredOptions | async; track option.email || option.id) {
        <mat-option (onSelectionChange)="optionSelected(option)" [disabled]="isAlreadySelected(option)">
          {{ option.email }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <div class="selected-list">
    @for (option of selectedOptions; track option.email || option.id) {
      <div class="selected-item">
        <span class="user-name text-black">{{ option.email }}</span>
        <button class="border-0 bg-transparent delete-btn" (click)="remove(option)">
          <i class="das das-corss fs-12"></i>
        </button>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="pe-0" align="end">
  <button class="btn btn-outline-primary fs-14 rounded-1 fw-bold" (click)="select()">
    {{ 'eventAuditTrail.select' | translate }}
  </button>
</mat-dialog-actions>
